// https://docs.fineuploader.com/tag/3.8.2/features/handling-errors.html
export default {
    'it-IT': {
        messages: {
            typeError: '{file} ha una estensione non valida. Formati supportati: {extensions}.',
            sizeError: '{file} troppo grande, la dimensione massima è {sizeLimit}.',
            emptyError: '{file} è vuoto. Seleziona di nuovo i file senza di esso.',
            tooManyItemsError: 'Troppi elementi. Numero massimo di elementi ammesso: {itemLimit}.',
            attachYourImages: 'Allega le tue immagini',
            dropAreaText: 'Trascina qui le tue fotografie'
        },
        deleteFile: {
            confirmMessage: 'Sicuro di voler eliminare {filename}?'
        }
    },
    'fr-FR': {
        messages: {
            typeError: '{file} format de fichier non valide. Fromat supportés: {extensions}.',
            sizeError: '{file} trop grand, la dimensione maximale est {sizeLimit}.',
            emptyError: '{file} est vide. Veuillez sélectionner à nouveau les fichiers sans ceci.',
            tooManyItemsError: "Trop d'éléments. Le nombre maximal d'éléments est: {itemLimit}.",
            attachYourImages: 'Joignez vos images',
            dropAreaText: 'Faites glisser vos photos ici'
        },
        deleteFile: {
            confirmMessage: 'Etes-vous sûr que vous voulez supprimer {filename}?'
        }
    },
    'es-ES': {
        messages: {
            typeError: '{file} tiene una extensión no válida. Formatos soportados: {extensions}.',
            sizeError: '{file} demasiado grande, el tamaño máximo es {sizeLimit}.',
            emptyError: '{file} está vacío. Selecciona nuevamente un archivo.',
            tooManyItemsError: 'Demasiados elementos. Número máximo de elementos aceptados: {itemLimit}.',
            attachYourImages: 'Adjunta las imágenes',
            dropAreaText: 'Mueve aquí las fotografías'
        },
        deleteFile: {
            confirmMessage: '¿Estás seguro que lo quieres eliminar {filename}?'
        }
    },
    'en-GB': {
        messages: {
            typeError: '{file} has an invalid extension. Valid extension(s): {extensions}.',
            sizeError: '{file} is too large, maximum file size is {sizeLimit}.',
            emptyError: '{file} is empty, please select files again without it.',
            tooManyItemsError: 'Too many items. Maximum number of items allowed: {itemLimit}.',
            attachYourImages: 'Attach your images',
            dropAreaText: 'Drag here your pictures'
        },
        deleteFile: {
            confirmMessage: 'Are you sure you want to delete {filename}?'
        }
    },
    'en-US': {
        messages: {
            typeError: '{file} has an invalid extension. Valid extension(s): {extensions}.',
            sizeError: '{file} is too large, maximum file size is {sizeLimit}.',
            emptyError: '{file} is empty, please select files again without it.',
            tooManyItemsError: 'Too many items. Maximum number of items allowed: {itemLimit}.',
            attachYourImages: 'Attach your images',
            dropAreaText: 'Drag here your pictures'
        },
        deleteFile: {
            confirmMessage: 'Are you sure you want to delete {filename}?'
        }
    },
    'de-DE': {
        messages: {
            typeError: '{file} hat eine ungültige Größe. Unterstützte Formate: {extensions}.',
            sizeError: '{file} zu groß, die maximale Größe ist {sizeLimit}.',
            emptyError: '{file} ist leer. Bitte erneut die Dokumente auswählen ohne diesem.',
            tooManyItemsError: 'zu viele Objekte. Maximale Anzahl an Objekte: {itemLimit}.',
            attachYourImages: 'Fügen Sie ihre Bilder ein',
            dropAreaText: 'Ziehen Sie Ihre Bilder per Drag & Drop hierher'
        },
        deleteFile: {
            confirmMessage: 'Sind Sie sicher, dass Sie löschen möchten {filename}?'
        }
    },
    'en-AU': {
        messages: {
            typeError: '{file} has an invalid extension. Valid extension(s): {extensions}.',
            sizeError: '{file} is too large, maximum file size is {sizeLimit}.',
            emptyError: '{file} is empty, please select files again without it.',
            tooManyItemsError: 'Too many items. Maximum number of items allowed: {itemLimit}.',
            attachYourImages: 'Attach your images',
            dropAreaText: 'Drag here your pictures'
        },
        deleteFile: {
            confirmMessage: 'Are you sure you want to delete {filename}?'
        }
    },
    'ko-KR': {
        messages: {
            typeError: '{file} 확장명이 유효하지 않습니다. 사용 가능한 확장자는 {extensions}입니다.',
            sizeError: '{file} 파일 용량이 초과 되었습니다, 최대 용량은 {sizeLimit}입니다.',
            emptyError: '{file} 비어있습니다. 이것을 포함하지말고 파일을 선택하십시오. ',
            tooManyItemsError: ' 너무 많는 아이템을 선택하셨습니다. 최대 수량은 {itemLimit}입니다.',
            attachYourImages: '이미지를 추가하십시오.',
            dropAreaText: '사진을 이곳에 드래그 하십시오.'
        },
        deleteFile: {
            confirmMessage: '{filename} 이 파일을 삭제하시겠습니까?'
        }
    }
}